import React from 'react';
import Image from "next/legacy/image";

import { FaTwitter } from 'react-icons/fa';

const TeamMember = ({ name, title, image, twitter, children }) => {
  return (
    <>
      <div className="py-3 d-flex align-items-center flex-column flex-sm-row flex-lg-column">
        <div className="w-50">
          <Image
            src={image}
            alt={name}
            width={600}
            height={600}
            className="rounded-circle overflow-hidden"
          />
        </div>
        <div className="px-3 text-center text-sm-start text-lg-center w-100">
          <div className="title fs-2">{name}</div>
          <div className="lead fw-bold">{title}</div>
          <a
            className="fs-4"
            href={`https://twitter.com/${twitter}`}
            target="_blank"
            rel="noreferrer"
          >
            <FaTwitter />
          </a>
          <div className="py-3">{children}</div>
        </div>
      </div>
    </>
  );
};

export default TeamMember;
